<template>
  <div>
    <el-dialog
      :title="Title"
      class="taskSearch"
      custom-class="dialog"
      @opened="opened"
      :visible.sync="taskSearchDialog"
      width="90%"
      top="20"
      append-to-body
    >
      <div slot="title" class="dialog-title">
        <span>{{Title}}</span>
        <el-radio-group
          v-model="Alone.typeView"
          @change="typeViewchange"
          style="padding-left:10px;"
        >
          <el-radio :label="0">&nbsp;个人任务</el-radio>
          <el-radio :label="1">&nbsp;团队任务</el-radio>
        </el-radio-group>
        <span style="margin-left: 20px;">{{Alone.typeView==1?"搜索结果为本人管理团队中的任务":"搜索结果为本人是任务干系人的任务"}}</span>
      </div>
      <el-form ref="form" class="searchForm1" label-width="80px" size="small">
        <el-row v-show="Alone.typeView==1" class="formitem1" :gutter="20">
          <el-col :span="20">
            <el-form-item label="机构组织">
              <ayb-SelectTeam
                :setWidth="'100%'"
                :disabled="Alone.meCompanyDept"
                :idArray="Alone.TaskRightIds"
                @getValue="getCompanyDept"
                ref="SelectedCompanyDept1"
              ></ayb-SelectTeam>
              <!--<el-radio-group max="1" v-model="Alone.serviceDesk" :disabled="Alone.meCompanyDept">
                <el-radio @click.native.prevent="serviceDeskclickitem(1)" :label="1">我在线的服务台</el-radio>
                <el-radio @click.native.prevent="serviceDeskclickitem(2)" :label="2">我所在的服务台</el-radio>
              </el-radio-group>-->
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-checkbox
              border
              size="medium"
              v-model="Alone.meCompanyDept"
              @change="meCompanyDeptChange"
            >全部</el-checkbox>
          </el-col>
          <!-- <el-col :span="12">
            <el-tooltip
              class="item"
              effect="dark"
              :content="Alone.ServerCenterName"
              placement="top"
            >
              <el-form-item label="服务台">
                <el-select
                  size="small"
                  :disabled="Alone.meServiceCenter"
                  :multiple="true"
                  :filter-method="filterText"
                  :style="{width: setWidth}"
                  v-model="Alone.ServerCenterIds"
                  @change="getServerCenter"
                  filterable
                  placeholder="请选服务台"
                >
                  <el-option
                    v-for="item in serviceList"
                    :key="item.ID"
                    :label="item.NAME"
                    :value="item.ID"
                  >
                    <span style="float: left">{{ item.NAME }}</span>
                    <span
                      style="float: right; color: #8492a6;padding-right: 20px;"
                    >{{ item.DEPTNAME+' - '+item.COMPANYNAME }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建人">
              <div style="width:80%;float:left;">
                <ayb-select-user
                  :isRadio="false"
                  :setWidth="setWidth"
                  :idArray="Alone.CreateUserIds"
                  @getValue="getCreateUser"
                  ref="selectedCreateUser"
                ></ayb-select-user>
              </div>
              <div style="float:left;width: 20%;">
                <el-checkbox border v-model="Alone.CreateMe">本人</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行人">
              <div style="width:80%;float:left;">
                <ayb-select-user
                  :isRadio="false"
                  :setWidth="setWidth"
                  :idArray="Alone.ExcuteUserIds"
                  @getValue="getExcuteUser"
                  ref="selectedExcuteUser"
                ></ayb-select-user>
              </div>
              <div style="float:left;width: 20%;">
                <el-checkbox border v-model="Alone.ExcuteMe">本人</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="流转人">
              <div style="width:80%;float:left;">
                <ayb-select-user
                  :isRadio="false"
                  :setWidth="setWidth"
                  :idArray="Alone.ConvertUserIds"
                  @getValue="getConvertUser"
                  ref="selectedConvertUser"
                ></ayb-select-user>
              </div>
              <div style="float:left;width: 20%;">
                <el-checkbox border v-model="Alone.ConvertMe">本人</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="干系人">
              <div style="width:80%;float:left;">
                <ayb-select-user
                  :isRadio="false"
                  :setWidth="setWidth"
                  :idArray="Alone.TaskMemeberIds"
                  @getValue="getTaskMemeber"
                  ref="selectedConvertUser"
                ></ayb-select-user>
              </div>
              <div style="float:left;width: 20%;">
                <el-checkbox border v-model="Alone.TaskMemeberMe">本人</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line1">
          <!-- <el-col :span="24">
            <el-form-item label="选择设备" >
              <ayb-DeviceObjectList @getValue="getTaskSelectedInstance" :isCuoZuo="false"></ayb-DeviceObjectList>
        	</el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="任务名称">
              <el-input class="searchInput" placeholder="请输入任务名称" v-model="searchParams.TaskName"></el-input>
            </el-form-item>
          </el-col>
          <!--<el-col :span="8">
            <el-form-item label="排序方式">
              <el-tooltip class="item" effect="dark" :content="Alone.OrderTime" placement="top">
                <el-select
                  v-model="searchParams.OrderTime"
                  @change="orderTimeChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="orderTime in orderTimeOptions"
                    :key="orderTime.value"
                    :label="orderTime.label"
                    :value="orderTime.value"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="执行状态">
              <el-tooltip class="item" effect="dark" :content="Alone.stateName" placement="top">
                <el-select
                  class="searchInput"
                  multiple
                  filterable
                  v-model="searchParams.state"
                  @change="stateChange"
                  placeholder="请选择"
                >
                  <el-option-group
                    v-for="group in groupStateOptions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in stateOptions.filter(o=>o.value.indexOf(group.value)>-1)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="任务来源">
              <el-tooltip class="item" effect="dark" :content="Alone.SourceName" placement="top">
                <el-select
                  class="searchInput"
                  @change="sourceChange"
                  multiple
                  v-model="searchParams.CreateSource"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in createSourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="任务等级">
              <el-tooltip
                class="item"
                effect="dark"
                :content="Alone.TaskDegreeName"
                placement="top"
              >
                <el-select
                  class="searchInput"
                  multiple
                  filterable
                  @change="taskClassChange"
                  v-model="searchParams.TaskDegree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in degreeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="故障类型">
              <ayb-selectMaintenance
                :idArray="Alone.FaultType"
                @getValue="mtGetValue"
                ref="faultTypeSelect"
              ></ayb-selectMaintenance>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="故障设备">
              <selectDeviceExample
                :idArray="Alone.DeviceIds"
                @getValue="SelGetValue"
                ref="deviceSelect"
              ></selectDeviceExample>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-tooltip class="item" effect="dark" :content="Alone.taskTypeName" placement="top">
              <el-form-item label="任务类型">
                <el-select
                  class="searchInput"
                  multiple
                  filterable
                  clearable
                  v-model="searchParams.TaskType"
                  @change="TaskTypeChange"
                  placeholder="请选择"
                >
                  <el-option-group
                    v-for="group in groupOptions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in taskTypeOptions.filter(o=>o.CLASSID==group.value)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="8">
            <el-form-item label="任务编号">
              <el-input
                class="searchInput"
                placeholder="请输入任务编号"
                v-model="searchParams.TaskInstance"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="超期">
              <el-tooltip class="item" effect="dark" :content="Alone.OutOfDateName" placement="top">
                <el-select
                  class="searchInput"
                  @change="OutOfDateChange"
                  v-model="searchParams.OutOfDate"
                  collapse-tags
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in OutOfDateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="lineTop" v-if="TaskTypeCode.indexOf('1')>-1">
          <el-col :span="24">
            <el-tooltip class="item" effect="dark" :content="searchParams.Location" placement="top">
              <el-form-item label="故障地址">
                <!-- <el-input class="searchInput" placeholder="请输入故障地址" v-model="searchParams.Location"></el-input> -->
                <selectFuncRoom setWidth="100%" ref="selectFuncRoom" @getValue="toGetFuncRoomValue"></selectFuncRoom>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row class="lineTop" v-if="TaskTypeCode.indexOf('0')>-1">
          <el-col :span="6">
            <el-tooltip class="item" effect="dark" :content="Alone.taskTypeName" placement="top">
              <el-form-item label="来电号码">
                <el-input
                  class="searchInput"
                  placeholder="请输入来电号码"
                  v-model="searchParams.CallerPhone"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip class="item" effect="dark" :content="Alone.taskTypeName" placement="top">
              <el-form-item label="接听分机">
                <el-input
                  class="searchInput"
                  placeholder="请输入接听分机"
                  v-model="searchParams.ANSWERPHONE"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip class="item" effect="dark" :content="Alone.taskTypeName" placement="top">
              <el-form-item label="接听类型">
                <el-select
                  class="searchInput"
                  filterable
                  clearable
                  v-model="searchParams.ANSWERTYPE"
                  @change="AnswerTypeChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in AnswerTypeState"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip class="item" effect="dark" :content="Alone.taskTypeName" placement="top">
              <el-form-item label="接听人员">
                <ayb-select-user
                  :isRadio="false"
                  :setWidth="setWidth"
                  :idArray="Alone.AnswerUserIds"
                  @getValue="getAnswerUser"
                  ref="selectedCAnswerUser"
                ></ayb-select-user>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <!--<el-col :span="16">
            <el-form-item label="展示方式">
              <el-radio-group v-model="Alone.ViewType">
                <el-radio v-for="(item, index) in ViewTypeState" :key="index" :label="item.value">{{item.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-tooltip class="item" effect="dark" :content="Alone.CreateClassName" placement="top">
              <el-form-item label="创建来源">
                <el-select
                  class="searchInput"
                  clearable
                  v-model="searchParams.CreateClass"
                  collapse-tags
                  @change="CreateClassChange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in createClassOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="8">
            <el-tooltip class="item" effect="dark" :content="Alone.TagNames" placement="top">
              <el-form-item label="任务标签">
                <el-select
                  multiple
                  v-model="Alone.TagIds"
                  class="searchInput"
                  placeholder="请选择"
                  clearable
                  @change="TaskTagChange"
                >
                  <el-option-group
                    v-for="group in tagOptions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(item,index) in group.options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span class="icon-span" :style="getColor(item.color)">
                        <i class="el-icon-price-tag"></i>
                      </span>
                      <span style="margin-left: 10px;font-size: 14px;">{{item.label}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <!-- <el-row class="line1">
          <el-col :span="8">
            <el-tooltip class="item" effect="dark" :content="Alone.TypeIndexName" placement="top">
              <el-form-item label="角色分类">
                <el-select
                  class="searchInput"
                  @change="TypeIndexChange"
                  v-model="searchParams.TypeIndex"
                  collapse-tags
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeIndexOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>-->

        <el-row class="line1"></el-row>
        <el-row class="formitem" :gutter="20">
          <el-col :span="12">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="Alone.createtimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group max="1" v-model="Alone.createtimeRadio">
              <el-radio @click.native.prevent="createclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="createclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="createclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.createtimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.createTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="接收时间">
              <el-date-picker
                v-model="Alone.receiveTimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.receiveTimeRadio">
              <el-radio @click.native.prevent="receiveclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="receiveclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="receiveclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.receiveTimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.receiveTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="formitem" :gutter="20">
          <el-col :span="12">
            <el-form-item label="流转时间">
              <el-date-picker
                v-model="Alone.circulationtimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.circulationtimeRadio">
              <el-radio @click.native.prevent="circulationclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="circulationclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="circulationclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.circulationtimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              clearable
              v-model="Alone.circulationTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="审批时间">
              <el-date-picker
                v-model="Alone.audittimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.audittimeRadio">
              <el-radio @click.native.prevent="auditclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="auditclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="auditclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.audittimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.auditTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="formitem" :gutter="20">
          <el-col :span="12">
            <el-form-item label="完成时间">
              <el-date-picker
                v-model="Alone.completetimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.completetimeRadio">
              <el-radio @click.native.prevent="completeclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="completeclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="completeclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.completetimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.completeTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="关闭时间">
              <el-date-picker
                v-model="Alone.closetimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.closetimeRadio">
              <el-radio @click.native.prevent="closeclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="closeclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="closeclickitem(3)" :label="3">最近</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.closetimeInput" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.closeTimeDynamic"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="formitem" :gutter="20">
          <el-col :span="12" style="margin-top: 10px;">
            <el-form-item label="逾期时间">
              <el-date-picker
                v-model="Alone.overduetimeRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="Alone.overduetimeRadio">
              <el-radio @click.native.prevent="overdueclickitem(1)" :label="1">最近七天</el-radio>
              <el-radio @click.native.prevent="overdueclickitem(2)" :label="2">最近一个月</el-radio>
              <el-radio @click.native.prevent="overdueclickitem(3)" :label="3">最近</el-radio>
              <el-input class="inputtime" v-model="Alone.overduetimeInput" size="mini"></el-input>
              <el-select
                class="searchTime"
                size="mini"
                v-model="Alone.overduetimeDynamic"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in timeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-radio-group>
            <el-radio-group v-model="Alone.overduetimeRadio">
              <el-radio @click.native.prevent="overdueclickitem(5)" :label="5">后七天 &nbsp;&nbsp;</el-radio>
              <el-radio @click.native.prevent="overdueclickitem(6)" :label="6">后一个月 &nbsp;&nbsp;</el-radio>
              <el-radio @click.native.prevent="overdueclickitem(4)" :label="4">后 &nbsp;&nbsp;</el-radio>
            </el-radio-group>
            <el-input class="inputtime" v-model="Alone.overduetimeInput2" size="mini"></el-input>
            <el-select
              class="searchTime"
              size="mini"
              v-model="Alone.overduetimeDynamic2"
              placeholder="请选择"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" style="text-align: center;font-size: 16px;" class="dialog-footer">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="搜索结果展示方式" name="1">
            <el-row style="font-size: 16px;">
              <el-col :span="4">正序/倒序</el-col>
              <el-col :span="20" class="txtleft">
                <el-radio-group v-model="Alone.orderRule" style="padding-left:10px;">
                  <el-radio label="ASC">正序</el-radio>
                  <el-radio label="DESC">倒序</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="font-size: 16px;">
              <el-col :span="4">排序方式</el-col>
              <el-col :span="20" class="txtleft">
                <el-radio-group v-model="Alone.OrderTime" style="padding-left:10px;">
                  <el-radio
                    :label="item.value"
                    v-for="item in orderTimeOptions"
                    :key="item.value"
                  >{{item.label}}</el-radio>
                </el-radio-group>
                <!--<el-tooltip class="item" effect="dark" :content="Alone.OrderTime" placement="top">
                  <el-select
                    v-model="searchParams.OrderTime"
                    @change="orderTimeChange"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="orderTime in orderTimeOptions"
                      :key="orderTime.value"
                      :label="orderTime.label"
                      :value="orderTime.value"
                    ></el-option>
                  </el-select>
                </el-tooltip>-->
              </el-col>
            </el-row>
            <el-row style="font-size: 16px;">
              <el-col :span="4">展示视图</el-col>
              <el-col :span="20" class="txtleft">
                <el-radio-group v-model="Alone.ViewType" style="padding-left:10px;">
                  <el-radio v-show="isFolder" label="folder">列表视图</el-radio>
                  <el-radio v-show="isCard" label="card">卡片视图</el-radio>
                  <!--<el-radio :label="item.value" v-for="item in ViewTypeState" :key="item.value">{{item.name}}</el-radio>-->
                </el-radio-group>
                <!--<el-select
                  class="searchInput"
                  filterable
                  clearable
                  size="mini"
                  style="width:150px"
                  v-model="Alone.ViewType"
                  placeholder="搜索结果展示视图"
                >
                  <el-option
                    v-for="item in ViewTypeState"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>-->
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-button
          class="btn"
          size="mini"
          v-show="TemplateType!=1"
          type="primary"
          @click="onSearch"
        >搜索</el-button>
        <el-button class="btn" size="mini" v-show="TemplateType!=1" @click="onClear">清空</el-button>
        <el-button
          class="btn"
          size="mini"
          v-show="TemplateType!=1"
          type="primary"
          @click="createTemplate"
        >保存模板</el-button>
        <el-button
          class="btn"
          size="mini"
          v-show="TemplateType==1"
          type="primary"
          @click="SaveTemplate"
        >保存</el-button>
        <el-button
          class="btn"
          size="mini"
          v-show="TemplateType==1"
          type="primary"
          @click="createTemplate"
        >另存为</el-button>
        <el-button
          class="btn"
          size="mini"
          v-show="TemplateType==1"
          @click="taskSearchDialog = false"
        >关闭</el-button>
        <createTemplate
          ref="createTemplate"
          :userId="userId"
          :body="true"
          @guanbi="guantc"
          :temType="0"
        ></createTemplate>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAllTag, getCommonTag } from "@/api/modules/basicData/task";
import commomSelect from "@/components/basicData/commonSelectComponent.vue";
import taskSearchTemplate from "./taskSearchTemplate.vue";
import selectCompanyDept from "@/components/basicData/selectCompanyDeptComponent.vue";
import selectServiceCenter from "@/components/basicData/selectServiceCenter.vue";
import exportExcel from "@/components/common/exportExcelComponent.vue";
import createTemplate from "@/components/MainLayout/template/createTemplate.vue";
import selectDeviceExample from "@/components/basicData/selectDeviceExample";
import selectFuncRoom from "@/components/basicData/selectFuncRoom.vue";
import {
  // GetTaskTypeList,
  getTaskListByParas,
  AddTaskSearchTemplate,
  GetTaskSearchTemplate,
  AddTemplate,
  UpdateTemplate,
  GetAllCompanyDeptContactInfo,
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
// import timeJs from "@/util/timeFormat";
import { GetAllServerCenter } from "@/api/modules/basicData/organization";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import searchJs from "@/util/search";
const cookieUser = getToken();
import {
  setConfig,
  getConfig,
  getAllSelectedParamsConfigs,
} from "@/api/modules/basicData/commonData.js";
export default {
  name: "TaskSearch",
  props: {
    taskClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tagOptions: [],
      activeNames: ["1"],
      TaskTypeCode: [], //任务类型编码
      TaskViewTypeState: [],
      isFolder: true,
      isCard: true,
      // ViewTypeState:[
      //   {name:'列表视图',value:'folder'},
      //   {name:'卡片视图',value:'card'}
      // ],
      userId: cookieUser.userId,
      selectRadioState: "fuwu",
      optionSel: {
        commomShowPlaceholder: "请选择",
        commonDialogTitle: "请选择",
        commonCheckedDescription: "已选",
        isRadio: false,
        setWidth: "100%",
        isStrictly: true, //父子节点不关联
      },
      dataSel: {
        imageType: [],
        idArray: [],
        checkField: {
          Id: "Id",
          Pid: "Pid",
          Key: "AggrID",
          Type: "Type",
          TypeValue: [0],
          ValidField: ["NAME", "PY", "FullPY"],
          ShowField: "NAME",
          ShowFieldName: "关键字",
        },
      },
      TemplateType: 0, //打开类型 0：精确查找 1：编辑模板
      Title: "搜索",
      serviceList: [], //服务台集合
      Alone: {
        //单独动态判断的前提条件
        orderRule: "DESC",
        TagIds: [],
        IsStateCondition: false, //执行状态使用本条件
        IsTeamCondition: false, //团队使用本条件
        ExcuteMe: false, //执行人本人
        CreateMe: false, //创建人本人
        ConvertMe: false,
        LinkManMe: false, //联系人本人
        TaskMemeberMe: false, //干系人本人
        meCompanyDept: true, //全部
        meServiceCenter: false, //我管理的服务台
        receiveTimeRange: [], //接收时间
        receiveTimeRadio: "", //接收时间选择
        receiveTimeInput: "", //接收时间填写
        receiveTimeDynamic: 1, //接收时间（小时,天，周，月）
        circulationtimeRange: [], //流转时间
        circulationtimeRadio: "", //流转时间选择
        circulationtimeInput: "", //流转时间填写
        circulationTimeDynamic: 1, //流转时间（小时,天，周，月）
        audittimeRange: [], //审批时间
        audittimeRadio: "", //审批时间选择
        audittimeInput: "", //审批时间填写
        auditTimeDynamic: 1, //审批时间（小时,天，周，月）
        completetimeRange: [], //完成时间
        completetimeRadio: "", //完成时间选择
        completetimeInput: "", //完成时间填写
        completeTimeDynamic: 1, //完成时间（小时,天，周，月）
        createtimeRange: [], //创建时间
        createtimeRadio: "", //创建时间选择
        createtimeInput: "", //创建时间填写
        createTimeDynamic: 1, //创建时间（小时,天，周，月）
        closetimeRange: [], //关闭时间
        closetimeRadio: "", //关闭时间选择
        closetimeInput: "", //关闭时间填写
        closeTimeDynamic: 1, //关闭时间（小时,天，周，月）
        overduetimeRange: [], //逾期时间
        overduetimeRadio: "", //逾期时间选择
        overduetimeInput: "", //逾期时间填写
        overduetimeDynamic: 1, //逾期时间（小时,天，周，月）
        overduetimeInput2: "", //逾期时间填写
        overduetimeDynamic2: 1, //逾期时间（小时,天，周，月）
        companyDeptCheckList: [1, 2], //组织机构人员选择
        ExcuteUserIds: [], //控件中执行人Ids
        CreateUserIds: [], //控件中创建人Ids
        ConvertUserIds: [],
        MemeberUserIds: [], //控件中干系人Ids
        LinkUserIds: [], //控件中联系人Ids
        TaskRightIds: [], //控件中组织机构Ids
        DeviceIds: [], //控件中设备Ids
        selectedCreateUser: [],
        selectedExcuteUser: [],
        selectedConvertUser: [],
        ServerCenterIds: [], //服务台
        FaultType: [], //故障类型
        stateName: "", //执行状态
        taskTypeName: "", //任务类型
        TaskDegreeName: "", //任务等级
        SourceName: "", //保修来源
        OutOfDateName: "", //超期名称
        FaultTypeName: "", //故障类型名称
        DeviceName: "", //故障设备名称
        TypeIndexName: "", //角色分类
        CreateClassName: "", //创建来源
        TaskRightName: "", //组织机构名称
        ExcuteUserName: "", //执行人名称
        CreateUserName: "", //创建人名称
        ConvertUserName: "",
        MemeberUserName: "", //干系人名称
        LinkUserName: "", //联系人名称
        ServerCenterName: "", //服务台名称
        TaskRightTypes: [], ////组织机构加type，防止出现多个
        TaskClass: "", //大类,
        OrderTime: "ACTUALOPERATETIME", //排序方式
        typeView: 0,
        serviceDesk: "",
        ViewType: "",
        ViewTypeName: "",
        AnswerUserName: "", //接听人名称
        AnswerTypeName: "", //接听类型名称
        AnswerUserIds: [], //接听人
      },
      taskSearchDialog: false,
      faultTypeList: [], //故障类型
      setWidth: "100%",
      setPeopleWidth: "30%",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      templateVisible: false,
      templateData: [],
      currentTemplateRow: null,
      groupOptions: [
        {
          label: "执行类",
          value: "fuwu",
        },
        {
          label: "审批类",
          value: "shenpi",
        },
        {
          label: "命令类",
          value: "mingling",
        },
      ],
      orderTimeOptions: [
        {
          label: "操作时间",
          value: "ACTUALOPERATETIME",
        },
        {
          label: "创建时间",
          value: "CREATETIME",
        },
        {
          label: "完成时间",
          value: "COMPLETTIME",
        },
      ],
      stateOptions: [],
      groupStateOptions: [
        {
          label: "执行类",
          value: "fuwu",
        },
        {
          label: "审批类",
          value: "shenpi",
        },
        {
          label: "命令类",
          value: "mingling",
        },
      ],
      fuwuOptions: [
        {
          label: "待接收",
          value: "fuwu_0",
        },
        {
          label: "执行中",
          value: "fuwu_1",
        },
        {
          label: "已完成",
          value: "fuwu_2",
        },
        {
          label: "已关闭",
          value: "fuwu_3",
        },
        {
          label: "待审批",
          value: "shenpi_0",
        },
        {
          label: "审批通过",
          value: "shenpi_2",
        },
        {
          label: "审批未通过",
          value: "shenpi_1",
        },
        {
          label: "待接收",
          value: "mingling_0",
        },
        {
          label: "待执行",
          value: "mingling_1",
        },
        {
          label: "正在执行",
          value: "mingling_2",
        },
        {
          label: "执行完毕",
          value: "mingling_3",
        },
        // {
        //   label: "挂起中",
        //   value: "fuwu_5"
        // },
        {
          label: "已作废",
          value: "fuwu_-1",
        },
      ], //任务状态
      shenpiOptions: [
        {
          label: "审批中",
          value: "0",
        },
        {
          label: "审批通过",
          value: "1",
        },
        {
          label: "审批不通过",
          value: "2",
        },
      ],
      OutOfDateOptions: [
        {
          label: "全部",
          value: "0",
        },
        {
          label: "未超期",
          value: "1",
        },
        {
          label: "已超期",
          value: "2",
        },
      ], //超期
      createClassOptions: [
        // {
        //   label: "所有",
        //   value: ""
        // },
        {
          label: "系统创建",
          value: "0",
        },
        {
          label: "人工创建",
          value: "1",
        },
      ], //创建来源
      createSourceOptions: [
        //报修来源
        {
          label: "PC桌面",
          value: "0",
        },
        {
          label: "微信",
          value: "1",
        },
        {
          label: "电话",
          value: "2",
        },
        {
          label: "网站",
          value: "3",
        },
        {
          label: "邮件",
          value: "5",
        },
        {
          label: "监控",
          value: "6",
        },
        {
          label: "运维APP",
          value: "7",
        },
        {
          label: "统一桌面",
          value: "8",
        },
      ],
      typeIndexOptions: [
        //角色分类
        {
          label: "我接收的",
          value: "0",
        },
        {
          label: "我创建的",
          value: "1",
        },
        {
          label: "我分派的",
          value: "2",
        },
        {
          label: "我流转的",
          value: "3",
        },
        {
          label: "我参与的",
          value: "4",
        },
        {
          label: "我关注的",
          value: "5",
        },
      ],
      degreeOptions: [
        //任务等级
        {
          label: "重要且紧急",
          value: "0",
        },
        {
          label: "重要不紧急",
          value: "1",
        },
        {
          label: "紧急不重要",
          value: "2",
        },
        {
          label: "不重要不紧急",
          value: "3",
        },
      ],
      timeOptions: [
        {
          label: "小时",
          value: 1,
        },
        {
          label: "天",
          value: 2,
        },
        {
          label: "周",
          value: 3,
        },
        {
          label: "月",
          value: 4,
        },
      ],
      companyDeptOptions: [
        {
          label: "创建人",
          value: 1,
        },
        {
          label: "执行人",
          value: 2,
        },
        // {
        // 	label: "干系人",
        // 	value: 3
        // },
        // {
        // 	label: "联系人",
        // 	value: 4
        // }
      ],
      exportCols: [
        "任务编号",
        "执行状态",
        "任务名称",
        "创建人",
        "创建时间",
        "报修来源",
        "任务类型",
        "执行人员",
        "服务台",
        "接收时间",
        "完成时间",
        "任务等级",
        "关注度",
      ],
      exportFields: [
        "INSTANCE",
        "TASKSTATENAME",
        "TASKNAME",
        "CREATEUSERNAME",
        "CREATETIME",
        "CREATESOURCENAME",
        "TASKTYPENAME",
        "EXCUTEUSERNAME",
        "SERVERCENTERNAME",
        "ACCEPTTIME",
        "COMPLETETIME",
        "TASKDEGREENAME",
        "FOCUSDEGREENAME",
      ],
      exportData: [], //导出数据
      // taskTypeOptions: [],
      createUser: null,
      excuteUser: null,
      convertUser: null,
      bqName: null,
      // dialogTemplate: false, //生成模板弹窗
      templateName: "", //模板名称
      // temClass: '', // s所有分组
      temClassObj: "", //  选中的那一个分组
      shuzi: 1,
      // isHit: null, // 当前选中的一个分组index
      typeView: 0,
    };
  },
  computed: {
    ...mapState({
      // ViewTypeState: state => state.task.ViewTypeState,
      AnswerTypeState: (state) => state.task.AnswerTypeState,
      TaskTypeByView: (state) => state.task.TaskTypeByView,
      taskStyle: (state) => state.task.taskStyle,
    }),
    templateTag: function () {
      return this.$store.state.task.templateTag;
    },
    searchParams: function () {
      return this.$store.state.task.searchParams;
    },
    tempType: function () {
      return this.$store.state.task.tempType;
    },
    // 		icons: function() {
    // 		return this.$store.state.task.icons;
    // 		},
    tagLength: function () {
      return this.$store.state.task.tagLength;
    },
    taskTypeOptions: function () {
      return this.$store.state.task.taskTypeOptions;
    },
    // 		taskSearchDialog: function(){
    // 		return this.$store.state.task.taskSearchDialog;
    // 		}
    // 		allVisibleTem: function() {
    // 		return this.$store.state.task.allVisibleTem;
    // 		},
  },
  methods: {
    getColor(color) {
      return `color:${color}`;
    },
    typeViewchange(val) {
      switch (val) {
        case 0:
          console.log(val);
          this.Alone.meCompanyDept = true;
          this.Alone.TaskRightIds = [];
          break;
      }
    },
    SelGetValue(value, callback) {
      console.log("设备", value);
      // this.Alone.DeviceIds = value.map(function(item) {
      // 		return item.ID;
      // 	})
      // 	.join(",");
      if (value.length > 0) {
        this.$store.state.task.searchParams.DeviceId =
          value[0].SocialId +
          "," +
          parseInt(value[0].SocialId.substr(value[0].SocialId.length - 1, 1)); //value[0].Type;
      } else {
        this.$store.state.task.searchParams.DeviceId = "";
      }
      this.Alone.DeviceName = value
        .map(function (item) {
          return item.Name;
        })
        .join(",");
    },
    toGetFuncRoomValue(data) {
      if (data.length > 0) {
        // this.createTaskMeg.funcRoom = data[0];
        this.searchParams.Location = data[0];
      } else {
        this.searchParams.Location = null;
      }
    },
    classifyChange(val) {
      this.stateOptions = this.fuwuOptions;
      // console.log("分类", val);
      // switch (val) {
      //   case "fuwu":
      //     this.stateOptions = this.fuwuOptions;
      //     break;
      //   case "shenpi":
      //     this.stateOptions = this.shenpiOptions;
      //     break;
      //   default:
      //     this.stateOptions = this.fuwuOptions;
      //     break;
      // }
    },
    taskTypeCode(val) {
      if (val.length > 0)
        this.TaskTypeCode = this.taskTypeOptions
          .filter((item) => val.indexOf(item.value) > -1)
          .map((p) => {
            return p.code;
          }); //[0].code;
    },
    SelSetValue(value, callback) {
      GetAllCompanyDeptContactInfo()
        .then((res) => {
          for (let i = 0; i < res.length; i++) {
            res[i].AggrID = res[i].ID + "_" + res[i].Type;
          }
          callback(res);
        })
        .catch((err) => {
          console.log("GetCompanyAllGeneralSelTree err");
        });
    },
    serviceDeskclickitem(e) {
      if (this.Alone.meCompanyDept == false) {
        e === this.Alone.serviceDesk
          ? (this.Alone.serviceDesk = "")
          : (this.Alone.serviceDesk = e);
      }
    },
    createclickitem(e) {
      e === this.Alone.createtimeRadio
        ? (this.Alone.createtimeRadio = "")
        : (this.Alone.createtimeRadio = e);
    },
    receiveclickitem(e) {
      e === this.Alone.receiveTimeRadio
        ? (this.Alone.receiveTimeRadio = "")
        : (this.Alone.receiveTimeRadio = e);
    },
    circulationclickitem(e) {
      e === this.Alone.circulationtimeRadio
        ? (this.Alone.circulationtimeRadio = "")
        : (this.Alone.circulationtimeRadio = e);
    },
    auditclickitem(e) {
      e === this.Alone.audittimeRadio
        ? (this.Alone.audittimeRadio = "")
        : (this.Alone.audittimeRadio = e);
    },
    completeclickitem(e) {
      e === this.Alone.completetimeRadio
        ? (this.Alone.completetimeRadio = "")
        : (this.Alone.completetimeRadio = e);
    },
    closeclickitem(e) {
      e === this.Alone.closetimeRadio
        ? (this.Alone.closetimeRadio = "")
        : (this.Alone.closetimeRadio = e);
    },
    overdueclickitem(e) {
      e === this.Alone.overduetimeRadio
        ? (this.Alone.overduetimeRadio = "")
        : (this.Alone.overduetimeRadio = e);
    },

    filterText(val) {
      this.debouncedSearch(val);
    },
    guantc() {
      this.taskSearchDialog = false;
    },
    getCreateUser(items) {
      //获取创建人信息
      console.log("创建人", items);
      // this.createUser = val[0];
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.UserId);
      });
      items.forEach((c) => {
        nameArr.push(c.Name);
      });
      this.Alone.CreateUserName = nameArr.join(",");
      this.$store.state.task.searchParams.CreateUserIds = idArr.join(",");
    },
    getAnswerUser(items) {
      //获取创建人信息
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.UserId);
      });
      items.forEach((c) => {
        nameArr.push(c.Name);
      });
      this.Alone.AnswerUserName = nameArr.join(",");
      this.$store.state.task.searchParams.ANSWERUSERID = idArr.join(",");
    },
    getTaskMemeber(items) {
      //获取选中干系人信息
      // console.log(items, "选择干系人")
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.UserId);
      });
      items.forEach((c) => {
        nameArr.push(c.Name);
      });
      this.Alone.MemeberUserName = nameArr.join(",");
      this.$store.state.task.searchParams.TaskMemeberIds = idArr.join(",");
    },
    getLinkMan(items) {
      console.log("联系人", items);
      //获取选中联系人信息
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.ID);
      });
      items.forEach((c) => {
        nameArr.push(c.NAME);
      });
      this.Alone.LinkUserName = nameArr.join(",");
      this.$store.state.task.searchParams.LinkManIds = idArr.join(",");
      this.Alone.LinkManIds = items.map(function (item) {
        return item.ID + "_" + item.Type;
      });
    },
    orderTimeChange(vId) {
      this.orderTimeOptions.forEach((orderTime) => {
        if (orderTime.value == vId) {
          this.Alone.OrderTime = orderTime.label;
        }
      });
    },
    stateChange(vId) {
      //这个vId也就是value值
      var arr = [];
      this.stateOptions.forEach((a) => {
        vId.forEach((c) => {
          if (a.value == c) {
            arr.push(a.label);
          }
        });
      });
      this.Alone.stateName = arr.join(",");
    },
    TaskTypeChange(vId) {
      //这个vId也就是value值
      this.Alone.taskTypeName = "";
      var arr = [];
      let code = "";
      this.TaskTypeCode = [];
      let templateArr = [];
      this.taskTypeOptions.forEach((a) => {
        vId.forEach((c) => {
          if (a.value == c) {
            arr.push(a.label);
            this.TaskTypeCode.push(a.code);
            templateArr.push(a.TEMPLATEID);
          }
        });
      });
      console.log("TaskTypeCode", this.TaskTypeCode);
      console.log("taskTypeOptions", this.taskTypeOptions);
      this.Alone.taskTypeName = arr.join(",");
      if (templateArr.length === 1) {
        //一条数据
        let templateInfo = JSON.parse(
          localStorage.getItem("TaskTypeTempList")
        ).find((p) => p.ID === templateArr[0]);
        //ViewTypeState
        if (templateInfo) {
          if (templateInfo.LISTCOMPONENT || templateInfo.CARDCOMPONENT) {
            this.isFolder = templateInfo.LISTCOMPONENT ? true : false;
            this.isCard = templateInfo.CARDCOMPONENT ? true : false;
          } else {
            this.isFolder = templateInfo.LISTCOMPONENT ? true : false;
            this.isCard = templateInfo.CARDCOMPONENT ? true : false;
          }
        } else {
          this.isFolder = true;
          this.isCard = true;
        }
      } else {
        this.isFolder = true;
        this.isCard = true;
      }
      // this.getTypeView(vId);
    },
    getTypeView(vId) {
      let TypeViewList = this.TaskTypeByView.filter(
        (item) => vId.indexOf(item.typeId) > -1
      );
      console.log("TypeViewList", TypeViewList);
      console.log("TypeViewList", this.TaskTypeByView);
      if (TypeViewList.length > 0) {
        this.$store.state.task.ViewTypeState = TypeViewList;
      } else {
        this.$store.state.task.ViewTypeState = this.TaskViewTypeState;
      }
      if (this.Alone.ViewType) {
        let ViewItem = this.$store.state.task.ViewTypeState.filter(
          (item) => item.typeId == this.Alone.ViewType
        );
        // if (ViewItem.length == 0) {
        //   this.Alone.ViewType = "";
        // }
      }
      this.Alone.ViewType = this.$store.state.task.ViewTypeState[0].value;
    },
    AnswerTypeChange(vId) {
      this.Alone.taskTypeName = "";
      var arr = [];
      this.AnswerTypeState.forEach((a) => {
        if (a.value == vId) {
          arr.push(a.name);
        }
      });
      this.Alone.AnswerTypeName = arr.join(",");
    },
    taskClassChange(vId) {
      var arr = [];
      this.degreeOptions.forEach((a) => {
        vId.forEach((c) => {
          if (a.value == c) {
            arr.push(a.label);
          }
        });
      });
      this.Alone.TaskDegreeName = arr.join(",");
      console.log(this.Alone.TaskDegreeName, "任务等级");
    },
    sourceChange(vId) {
      console.log("报修来源", vId);
      var arr = [];
      this.createSourceOptions.forEach((a) => {
        vId.forEach((c) => {
          if (a.value == c) {
            arr.push(a.label);
          }
        });
      });
      this.Alone.SourceName = arr.join(",");
    },
    OutOfDateChange(vId) {
      console.log("报修来源", vId);
      var arr = [];
      this.OutOfDateOptions.forEach((a) => {
        if (a.value == vId) {
          arr.push(a.label);
        }
      });
      this.Alone.OutOfDateName = arr.join(",");
    },
    TypeIndexChange(vId) {
      console.log("角色分类", vId);
      var arr = [];
      this.typeIndexOptions.forEach((a) => {
        if (a.value == vId) {
          arr.push(a.label);
        }
      });
      this.Alone.TypeIndexName = arr.join(",");
    },
    TaskTagChange(vIds) {
      var arr = [];

      this.tagOptions[1].options.forEach((a) => {
        if (vIds.some((v) => v == a.value)) {
          arr.push(a.label);
        }
      });
      this.Alone.TagNames = arr.join(",");
    },
    CreateClassChange(vId) {
      var arr = [];
      this.createClassOptions.forEach((a) => {
        if (a.value == vId) {
          arr.push(a.label);
        }
      });
      console.log("创建来源", arr);
      this.Alone.CreateClassName = arr.join(",");
    },
    getExcuteUser(items) {
      console.log("执行人", items);
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.UserId);
      });
      items.forEach((c) => {
        nameArr.push(c.Name);
      });
      // this.Alone.ExcuteUserIds = idArr;
      this.$store.state.task.searchParams.ExcuteUserIds = idArr.join(",");
      this.Alone.ExcuteUserName = nameArr.join(",");
      // this.excuteUser = items[0];
    },
    getConvertUser(items) {
      console.log("流转人", items);
      let idArr = [];
      let nameArr = [];
      items.forEach((c) => {
        idArr.push(c.UserId);
      });
      items.forEach((c) => {
        nameArr.push(c.Name);
      });
      // this.Alone.ExcuteUserIds = idArr;
      this.$store.state.task.searchParams.ConvertUserIds = idArr.join(",");
      this.Alone.ConvertUserName = nameArr.join(",");
      // this.excuteUser = items[0];
    },
    getServerCenter(vId) {
      console.log("服务台", this.serviceList);
      var arr = [];
      this.serviceList.forEach((a) => {
        vId.forEach((c) => {
          if (a.ID == c) {
            arr.push(a.NAME);
          }
        });
      });
      console.log("服务台", arr);
      this.Alone.ServerCenterName = arr.join(",");
      // this.$store.state.task.searchParams.ServerCenterIds = vId.join();
    },
    getCompanyDept(val) {
      console.log(val, "组织机构");
      this.$store.state.task.searchParams.TaskRightId = val
        .map(function (item) {
          return item.TeamId;
        })
        .join(",");
      this.Alone.TaskRightTypes = val.map(function (item) {
        return item.TeamId;
        // return item.SocialId + '_' + item.Type;
      });
      this.Alone.TaskRightName = val
        .map(function (item) {
          return item.Name;
        })
        .join(",");
    },
    getExportData: function (index, next) {
      //全部
      if (index === 0) {
        let paras = {
          PageIndex: 1,
          PageSize: this.$store.state.task.totalCount,
          TypeIndex: -1,
          TaskParas: this.$store.state.task.taskParas,
        };
        // new Promise((resolve, reject) => {
        getTaskListByParas(paras).then((data) => {
          if (data) {
            next(this.packageSource(data.Items));
          } else {
            next([]);
          }
        });
        // });
      } else {
        //当前页
        next(this.packageSource(this.$store.state.task.taskSource));
      }
    },
    packageSource: function (source) {
      source.forEach((o) => {
        o.CREATESOURCENAME = this.createSourceOptions.filter(
          (f) => f.value == o.CREATESOURCE
        )[0].label;
        o.TASKDEGREENAME = this.degreeOptions.filter(
          (f) => f.value == o.CREATESOURCE
        )[0].label;
        o.FOCUSDEGREENAME = this.focusDegreeFormater(o.FOCUSDEGREE);
      });
      return source;
    },
    ceshi() {
      console.log("测试");
      let obj = {
        a: 123,
        b: [1, 2, 3],
      };
      let para = Object.assign({}, obj);
      console.log(para, "para");
    },
    getPara(isType) {
      let para = JSON.parse(
        JSON.stringify(this.$store.state.task.searchParams)
      );
      // para.TaskClassCode = this.taskClass;
      console.log("searchParams666", this.$store.state.task.searchParams);
      para.TaskClassCode = this.Alone.TaskClass;
      // if (this.Alone.ViewType) {
      //   this.Alone.ViewTypeName = this.ViewTypeState.filter(
      //     item => item.value == this.Alone.ViewType
      //   )[0].name;
      // }
      para.Alone = this.Alone;
      // let AloneCondition = Object.assign({}, this.Alone);
      // console.log("时间类型", AloneCondition.createTimeDynamic);
      // console.log(para);
      // if (para.Alone.ViewType) {
      //   this.$store.state.task.viewType = para.Alone.ViewType;
      //   this.$store.state.task.ViewTypeName = para.Alone.ViewTypeName;
      // } else {
      //   let viewdata = this.$store.state.task.ViewTypeState;
      //   if (viewdata.length > 0) {
      //     this.$store.state.task.viewType = viewdata[0].value;
      //     this.$store.state.task.ViewTypeName = viewdata[0].name;
      //   }
      // }

      let searchTask = searchJs.searchTask(para, isType);
      if (isType == 0) {
        let templateVal = searchJs.searchTask(para, 2);
        templateVal.Alone = this.Alone;
        templateVal.queryTitle = this.queryTaskTitle();
        // this.$store.commit("setQueryTask", templateVal);
        this.$store.state.task.searchCondition = searchJs.setQueryTitle(
          templateVal.queryTitle,
          para.Alone
        );
        this.$store.state.task.isTemplateSearch = false;
      }

      return searchTask;
    },
    SearchOpen: function (type) {
      console.log("SearchOpen-Type", type);
      //打开方式 0:精确查找 1：编辑模板 默认精确查找
      switch (type) {
        case 0: //精确查找
          this.Title = "搜索";
          this.TemplateType = 0;
          this.$store.commit("setQueryTask", {
            isEmpty: true,
          });
          break;
        case 1: //编辑模板
          this.Title = "条件模板";
          this.dataSel.idArray = this.$store.state.task.Alone.LinkManIds;
          this.TemplateType = 1;
          break;
        case 2: //查询模板带出查询条件
          this.Title = "搜索";
          // this.dataSel.idArray = this.$store.state.task.Alone.LinkManIds;
          this.TemplateType = 0;
          this.searchParams.Alone = this.Alone;
          this.$store.state.task.searchParams = searchJs.serachTaskDisplay(
            this.searchParams
          );
          break;
        default:
          this.Title = "搜索";
          this.TemplateType = 0;
          this.$store.commit("setQueryTask", {
            isEmpty: true,
          });
          break;
      }
      this.taskSearchDialog = true;
    },
    onSearch: function (num) {
      this.$store.state.task.seekOrTag = false;
      this.$store.state.task.isDisabled = false;
      let SearchVal = this.getPara(0);

      // console.log(this.$store.state.task.serviceCenterName,"服务台")
      // 		this.$store.commit("getNowSeek", {
      // 		val: SearchVal,
      // 		num: '0'
      // 		});
      this.$store.state.task.searchCondition = searchJs.setQueryTitle(
        this.queryTaskTitle(),
        this.Alone
      );
      SearchVal.TaskStyle = this.taskStyle;
      this.$emit("onSearch", SearchVal);
      this.$store.dispatch("changeTaskParas", SearchVal);

      if (num != 6) {
        this.taskSearchDialog = false;
      }
      this.$store.state.task.isAllTask = false;
      this.$store.state.task.hhh = false;
    },
    allTask() {
      this.$store.state.task.searchParams = {
        TaskInstance: "",
        EventInstance: "",
        ExcuteState: "0,1,2,3,5,-1",
        TaskName: "",
        CreateTime2: "",
        CreateTime1: "",
        CreateUser: {},
        ExcuteUser: {},
        ConvertUser: {},
        state: [],
        TaskType: "",
        ServerCenterIds: "",
        CreateClass: "1",
        CreateSource: [],
        TypeIndex: "",
        TaskDegree: [],
      };
      this.$store.dispatch("changeTaskParas", this.getPara(0));
      this.$store.state.task.isAllTask = true;
    },
    focusDegreeFormater(val) {
      switch (val) {
        case 1:
          return "一级关注";
        case 2:
          return "二级关注";
        case 3:
          return "三级关注";
        default:
          return "";
      }
    },
    empty() {
      this.$refs.SelectedCompanyDept1.reset();
      this.$refs.selectedCreateUser.reset();
      this.$refs.selectedExcuteUser.reset();
      this.$refs.selectedConvertUser.reset();
      // this.$refs.selectedTaskMemeber.reset();
      // this.$refs.selectedLinkMan.deleteBtnClick();
      this.$refs.faultTypeSelect.reset();
      // this.$refs.deviceSelect.reset();
      this.$store.commit("setQueryTask", {
        isEmpty: true,
      });
    },
    onClear() {
      this.Alone = {
        //单独动态判断的前提条件
        ExcuteMe: false, //执行人本人
        CreateMe: false, //创建人本人
        ConvertMe: false,
        LinkManMe: false, //联系人本人
        TaskMemeberMe: false, //干系人本人
        ConvertUserIds: [],
        meCompanyDept: false, //全部
        meServiceCenter: false, //我管理的服务台
        receiveTimeRange: [], //接收时间
        receiveTimeRadio: "", //接收时间选择
        receiveTimeInput: "", //接收时间填写
        receiveTimeDynamic: 1, //接收时间（小时,天，周，月）
        circulationtimeRange: [], //流转时间
        circulationtimeRadio: "", //流转时间选择
        circulationtimeInput: "", //流转时间填写
        circulationTimeDynamic: 1, //流转时间（小时,天，周，月）
        audittimeRange: [], //审批时间
        audittimeRadio: "", //审批时间选择
        audittimeInput: "", //审批时间填写
        auditTimeDynamic: 1, //审批时间（小时,天，周，月）
        completetimeRange: [], //完成时间
        completetimeRadio: "", //完成时间选择
        completetimeInput: "", //完成时间填写
        completeTimeDynamic: 1, //完成时间（小时,天，周，月）
        createtimeRange: [], //创建时间
        createtimeRadio: "", //创建时间选择
        createtimeInput: "", //创建时间填写
        createTimeDynamic: 1, //创建时间（小时,天，周，月）
        closetimeRange: [], //关闭时间
        closetimeRadio: "", //关闭时间选择
        closetimeInput: "", //关闭时间填写
        closeTimeDynamic: 1, //关闭时间（小时,天，周，月）
        overduetimeRange: [], //逾期时间
        overduetimeRadio: "", //逾期时间选择
        overduetimeInput: "", //逾期时间填写
        overduetimeDynamic: 1, //逾期时间（小时,天，周，月）
        overduetimeInput2: "", //逾期时间填写
        overduetimeDynamic2: 1, //逾期时间（小时,天，周，月）
        companyDeptCheckList: [1, 2], //组织机构人员选择
        ExcuteUserIds: [], //控件中执行人Ids
        CreateUserIds: [], //控件中创建人Ids
        MemeberUserIds: [], //控件中干系人Ids
        LinkUserIds: [], //控件中联系人Ids
        TaskRightIds: [], //控件中组织机构Ids
        DeviceIds: [], //控件中设备Ids
        selectedCreateUser: [],
        selectedExcuteUser: [],
        ServerCenterIds: [], //服务台
        FaultType: [],
        stateName: "", //执行状态
        taskTypeName: "", //任务类型
        TaskDegreeName: "", //任务等级
        SourceName: "", //保修来源
        FaultTypeName: "", //故障类型名称
        DeviceName: "", //故障设备名称
        TypeIndexName: "", //角色分类
        CreateClassName: "", //创建来源
        TaskRightName: "", //组织机构名称
        ExcuteUserName: "", //执行人名称
        CreateUserName: "", //创建人名称
        MemeberUserName: "", //干系人名称
        LinkUserName: "", //联系人名称
        ServerCenterName: "", //服务台名称
        TaskRightTypes: [], //组织机构加type，防止出现多个
        OutOfDateName: "", //超期名称
        IsStateCondition: false,
        IsTeamCondition: false,
        TaskClass: "",
        typeView: 0,
        ViewType: "", //this.ViewTypeState[0].value,
        ViewTypeName: "",
        orderRule: "DESC",
        // OrderTime: "ACTUALOPERATETIME", //排序方式
      };
      // this.searchParams.OrderTime="ACTUALOPERATETIME"

      // console.error(this.Alone.FaultType)
      this.$store.commit("setQueryTask", {
        isEmpty: true,
      });
      // this.onSearch(6);
      // this.$store.state.task.taskType = "";
      // this.$store.dispatch("changeTaskParas", this.$store.state.task.searchParams);
    },
    selectTemplate() {
      //选择模板
      this.$refs.taskSearch.dialogVisible = true;
      this.$refs.taskSearch.cookieUser = cookieUser;
      GetTaskSearchTemplate(cookieUser.userId).then((res) => {
        console.log(res, "res");
        this.$refs.taskSearch.tableData = res;
      });
    },
    handleCurrentTemplateChange: function (val) {
      console.log(val, "valval");
      this.currentTemplateRow = val;
    },
    companyDeptCheckChange(value) {
      console.log("check", value);
    },
    meCompanyDeptChange(value) {
      if (value) {
        this.Alone.TaskRightIds = [];
        this.Alone.serviceDesk = "";
        this.Alone.meCompanyDept = true;
      }
      console.log("我管理的组织机构", value);
    },
    meServiceCenterChange(value) {
      if (value) {
        this.Alone.ServerCenterIds = [];
      }
    },
    createTemplate() {
      // searchJs.queryTaskTitle(this.getPara());
      this.$refs.createTemplate.open();
      let templateVal = this.getPara(2);
      templateVal.Alone = this.Alone;
      templateVal.queryTitle = this.queryTaskTitle();
      this.$refs.createTemplate.content = JSON.stringify(templateVal);
      console.log("模板内容", templateVal);
    },
    SaveTemplate() {
      let templateVal = this.getPara(2);
      templateVal.Alone = this.Alone;
      templateVal.queryTitle = this.queryTaskTitle();
      let obj = this.$store.state.task.tagItem;
      obj.CONTENT = JSON.stringify(templateVal);
      console.log("模板内容", templateVal);
      // console.log(this.$store.state.task.tagItem,"this.$store.state.task.tagItem")
      UpdateTemplate(obj, 0).then((res) => {});
      this.taskSearchDialog = false;
    },
    selectClass(val, index) {
      this.temClassObj = val;
      this.isHit = index;
      console.log(index);
    },
    getTaskSelectedInstance(data, sourceData, callback) {
      console.log("设备", sourceData);
      // this.Alone.DeviceIds = value.map(function(item) {
      // 		return item.ID;
      // 	})
      // 	.join(",");
      if (sourceData.length > 0) {
        this.$store.state.task.searchParams.DeviceId =
          sourceData[0].SocialId +
          "," +
          parseInt(
            sourceData[0].SocialId.substr(sourceData[0].SocialId.length - 1, 1)
          );
        // console.log("01",this.$store.state.task.searchParams.DeviceId)
      } else {
        this.$store.state.task.searchParams.DeviceId = "";
      }
      this.Alone.DeviceName = sourceData
        .map(function (item) {
          return item.Name;
        })
        .join(",");
      // console.log("02",this.Alone.DeviceName)
    },
    mtGetValue(value) {
      // this.faultTypeList.push(value)
      if (value) {
        console.log("故障类型1", value);
        this.$store.state.task.searchParams.FaultType = value.ID;
      } else {
        console.log("故障类型2", value);
        this.$store.state.task.searchParams.FaultType = "";
      }
      this.Alone.FaultTypeName = value.OBJECTFAULTNAME;
    },
    queryTaskTitle() {
      let queryTitle = [];
      queryTitle.push({
        title: "任务",
        key: "TypeView",
        value: this.Alone.typeView === 0 ? "个人" : "团队",
      });
      if (this.searchParams.TaskInstance)
        queryTitle.push({
          title: "任务编号",
          key: "TaskInstance",
          value: this.searchParams.TaskInstance,
        });
      if (this.searchParams.TaskName) {
        queryTitle.push({
          title: "任务名称",
          key: "TaskName",
          value: this.searchParams.TaskName,
        });
      }
      if (this.Alone.stateName) {
        queryTitle.push({
          title: "执行状态",
          key: "state",
          value: this.Alone.stateName,
        });
      }
      if (this.searchParams.CallerPhone) {
        queryTitle.push({
          title: "来电号码",
          key: "CallerPhone",
          value: this.searchParams.CallerPhone,
        });
      }
      if (this.searchParams.ANSWERPHONE) {
        queryTitle.push({
          title: "接听分机",
          key: "ANSWERPHONE",
          value: this.searchParams.ANSWERPHONE,
        });
      }
      if (this.Alone.AnswerTypeName) {
        queryTitle.push({
          title: "接听类型",
          key: "ANSWERTYPE",
          value: this.Alone.AnswerTypeName,
        });
      }
      if (this.Alone.AnswerUserName) {
        queryTitle.push({
          title: "接听人员",
          key: "ANSWERUSERID",
          value: this.Alone.AnswerUserName,
        });
      }
      if (this.searchParams.CallerPhone) {
        queryTitle.push({
          title: "来电号码",
          key: "CallerPhone",
          value: this.searchParams.CallerPhone,
        });
      }
      if (this.searchParams.Location) {
        queryTitle.push({
          title: "故障地址",
          key: "Location",
          value: this.searchParams.Location,
        });
      }
      if (this.Alone.FaultTypeName) {
        queryTitle.push({
          title: "故障类型",
          key: "Location",
          value: this.Alone.FaultTypeName,
        });
      }
      if (this.Alone.DeviceName) {
        queryTitle.push({
          title: "故障设备",
          key: "FaultType",
          value: this.Alone.DeviceName,
        });
      }
      if (this.Alone.taskTypeName) {
        queryTitle.push({
          title: "任务类型",
          key: "TaskType",
          value: this.Alone.taskTypeName,
        });
      }
      if (this.Alone.TaskDegreeName) {
        queryTitle.push({
          title: "任务等级",
          key: "TaskDegree",
          value: this.Alone.TaskDegreeName,
        });
      }
      if (this.Alone.SourceName) {
        queryTitle.push({
          title: "报修来源",
          key: "CreateSource",
          value: this.Alone.SourceName,
        });
      }
      if (this.Alone.OutOfDateName) {
        queryTitle.push({
          title: "超期",
          key: "OutOfDate",
          value: this.Alone.OutOfDateName,
        });
      }
      if (this.Alone.TypeIndexName) {
        queryTitle.push({
          title: "角色分类",
          key: "TypeIndex",
          value: this.Alone.TypeIndexName,
        });
      }
      if (this.Alone.CreateClassName) {
        queryTitle.push({
          title: "创建来源",
          key: "TypeIndex",
          value: this.Alone.CreateClassName,
        });
      }
      if (this.Alone.TagNames) {
        queryTitle.push({
          title: "任务标签",
          key: "TagIds",
          value: this.Alone.TagNames,
        });
      }
      if (this.Alone.typeView == 1) {
        if (this.Alone.TaskRightName || this.Alone.meCompanyDept) {
          let symbol = this.Alone.TaskRightName ? "-" : "";
          let arr = [];
          let personnel = "";
          this.companyDeptOptions.forEach((a) => {
            this.Alone.companyDeptCheckList.forEach((c) => {
              if (a.value == c) {
                arr.push(a.label);
              }
            });
          });
          personnel = arr.join(",");
          if (personnel) {
            personnel = "（" + personnel + "）";
          }
          queryTitle.push({
            title: "机构组织",
            key: "TaskRightId",
            value:
              this.Alone.TaskRightName +
              (this.Alone.meCompanyDept ? symbol + "全部" : "") +
              personnel,
          });
        }
      }
      if (this.Alone.ServerCenterName) {
        let symbol = this.Alone.ServerCenterName ? "," : "";
        queryTitle.push({
          title: "服务台",
          key: "ServerCenterName",
          value:
            this.Alone.ServerCenterName +
            (this.Alone.meServiceCenter ? symbol + "我管理的服务台" : ""),
        });
      }
      if (this.Alone.serviceDesk) {
        queryTitle.push({
          title: "服务台",
          key: "ServiceDeskName",
          value:
            this.Alone.serviceDesk == "1" ? "我在线的服务台" : "我所在的服务台",
        });
      }

      if (this.Alone.ExcuteUserName || this.Alone.ExcuteMe) {
        if (!this.Alone.ExcuteUserName) this.Alone.ExcuteUserName = "";
        let symbol = this.Alone.ExcuteUserName ? "," : "";
        queryTitle.push({
          title: "执行人",
          key: "ExcuteUserIds",
          value:
            this.Alone.ExcuteUserName +
            (this.Alone.ExcuteMe ? symbol + "本人" : ""),
        });
      }
      if (this.Alone.CreateUserName || this.Alone.CreateMe) {
        if (!this.Alone.CreateUserName) this.Alone.CreateUserName = "";
        let symbol = this.Alone.CreateUserName ? "," : "";
        queryTitle.push({
          title: "创建人",
          key: "CreateUserIds",
          value:
            this.Alone.CreateUserName +
            (this.Alone.CreateMe ? symbol + "本人" : ""),
        });
      }
      if (this.Alone.ConvertUserName || this.Alone.ConvertMe) {
        if (!this.Alone.ConvertUserName) this.Alone.ConvertUserName = "";
        let symbol = this.Alone.ConvertUserName ? "," : "";
        queryTitle.push({
          title: "流转人",
          key: "ConvertUserIds",
          value:
            this.Alone.ConvertUserName +
            (this.Alone.ConvertMe ? symbol + "本人" : ""),
        });
      }
      if (this.Alone.MemeberUserName || this.Alone.TaskMemeberMe) {
        if (!this.Alone.MemeberUserName) this.Alone.MemeberUserName = "";
        let symbol = this.Alone.MemeberUserName ? "," : "";
        queryTitle.push({
          title: "干系人",
          key: "TaskMemeberIds",
          value:
            this.Alone.MemeberUserName +
            (this.Alone.TaskMemeberMe ? symbol + "本人" : ""),
        });
      }
      if (this.Alone.LinkUserName || this.Alone.LinkManMe) {
        let symbol = this.Alone.LinkUserName ? "," : "";
        queryTitle.push({
          title: "联系人",
          key: "LinkManIds",
          value:
            this.Alone.LinkUserName +
            (this.Alone.LinkManMe ? symbol + "本人" : ""),
        });
      }
      let createtimeTitle = searchJs.timeTitle(
        this.Alone.createtimeRange,
        this.Alone.createtimeRadio,
        this.Alone.createtimeInput,
        this.Alone.createTimeDynamic
      );
      if (createtimeTitle) {
        queryTitle.push({
          title: "创建时间",
          key: "CreateTime",
          value: createtimeTitle,
        });
      }
      let receiveTimeTitle = searchJs.timeTitle(
        this.Alone.receiveTimeRange,
        this.Alone.receiveTimeRadio,
        this.Alone.receiveTimeInput,
        this.Alone.receiveTimeDynamic
      );
      if (receiveTimeTitle) {
        queryTitle.push({
          title: "接收时间",
          key: "AcceptTime",
          value: receiveTimeTitle,
        });
      }
      let circulationtimeTitle = searchJs.timeTitle(
        this.Alone.circulationtimeRange,
        this.Alone.circulationtimeRadio,
        this.Alone.circulationtimeInput,
        this.Alone.circulationtimeDynamic
      );
      if (circulationtimeTitle) {
        queryTitle.push({
          title: "流转时间",
          key: "TransferTime",
          value: circulationtimeTitle,
        });
      }
      let audittimeTitle = searchJs.timeTitle(
        this.Alone.audittimeRange,
        this.Alone.audittimeRadio,
        this.Alone.audittimeInput,
        this.Alone.auditTimeDynamic
      );
      if (audittimeTitle) {
        queryTitle.push({
          title: "审批时间",
          key: "AuditTime",
          value: audittimeTitle,
        });
      }
      let completetimeTitle = searchJs.timeTitle(
        this.Alone.completetimeRange,
        this.Alone.completetimeRadio,
        this.Alone.completetimeInput,
        this.Alone.completeTimeDynamic
      );
      if (completetimeTitle) {
        queryTitle.push({
          title: "完成时间",
          key: "CompleteTime",
          value: completetimeTitle,
        });
      }
      if (this.Alone.overduetimeRange) {
        let overduetimeTitle = "";
        if (this.Alone.overduetimeRadio >= 4) {
          overduetimeTitle = searchJs.timeTitle(
            this.Alone.overduetimeRange,
            this.Alone.overduetimeRadio,
            this.Alone.overduetimeInput2,
            this.Alone.overduetimeDynamic2
          );
        } else {
          overduetimeTitle = searchJs.timeTitle(
            this.Alone.overduetimeRange,
            this.Alone.overduetimeRadio,
            this.Alone.overduetimeInput,
            this.Alone.overduetimeDynamic
          );
        }

        if (overduetimeTitle) {
          queryTitle.push({
            title: "逾期时间",
            key: "overduetime",
            value: overduetimeTitle,
          });
        }
      }

      let closetimeTitle = searchJs.timeTitle(
        this.Alone.closetimeRange,
        this.Alone.closetimeRadio,
        this.Alone.closetimeInput,
        this.Alone.closeTimeDynamic
      );
      if (closetimeTitle) {
        queryTitle.push({
          title: "关闭时间",
          key: "CloseTime",
          value: closetimeTitle,
        });
      }

      if (this.Alone.OrderTime) {
        let OrderTitle = this.Alone.orderRule == "DESC" ? "倒序" : "正序";
        let orderTimeName = this.orderTimeOptions.find(
          (p) => p.value == this.Alone.OrderTime
        ).label;
        queryTitle.push({
          title: "排序方式",
          key: "OrderTime",
          value: orderTimeName + " " + OrderTitle,
        });
      }
      // let timeTitle = "";
      // switch (this.Alone.createtimeRadio) {
      // 	case 1: //最近七天
      // 		timeTitle='最近七天';
      // 		break;
      // 	case 1: //最近一个月
      // 	timeTitle='最近一个月';
      // 		break;
      // 	case 1: //最近填写的
      // 	    timeTitle='最近'+;
      // 		break;
      // 	default:
      // 		break;
      // }
      return queryTitle;
    },
    getServiceList(val) {
      GetAllServerCenter(val).then((response) => {
        // console.log(response, "response");
        this.serviceList = response;
        this.$store.state.task.serviceCenterList = response;
      });
    },
    opened() {
      // this.$refs.createTemplate.userId = cookieUser.userId;
    },
  },
  watch: {
    // taskClass(val) {
    // 	this.onSearch();
    // },
    // orderRule(newVal){
    //   console.log(newVal)
    // },
    ViewTypeState(val) {
      if (val) {
        this.Alone.ViewType = val[0].value;
      }
    },
    tempType(val) {
      console.log("watch:", val);
      this.SearchOpen(val);
    },
    // 		bqName(val) {
    // 		this.$store.state.task.templateTag = [];
    // 		val.forEach(c => {
    // 		this.templateTag.push(c);
    // 		});
    // 		this.templateTag.sort((a, b) => {
    // 		return a.ORDERINDEX - b.ORDERINDEX;
    // 		});
    // 		// console.log(this.templateTag, "templateTag")
    // 		},
    searchParams: function (pars) {
      console.log("searchParams222", pars);
      if (!pars) return;
      if (pars.Alone) {
        this.Alone = pars.Alone;
      } else {
        this.Alone = this.$store.state.task.Alone;
      }
      this.classifyChange(this.$store.state.task.Alone.TaskClass);
      this.taskTypeCode(pars.TaskType);
      this.getTypeView(pars.TaskType);
    },
  },
  mounted() {
    let type = this.$route.query.type;
    if (!type) type = 2;
    switch (parseInt(type)) {
      case 1:
        this.$store.state.task.searchParams.ServerCenterIds = this.$store.state.task.ServerCenterIds; //服务台
        this.$store.state.task.searchParams.CurrentUserId = "";
        break;
      case 2:
        this.$store.state.task.searchParams.CurrentUserId = cookieUser.userId; //个人任务
        this.$store.state.task.searchParams.ServerCenterIds = "";
        break;
      case 3:
        this.taskTypeName = "任务组";
        break;
      default:
        this.$store.state.task.searchParams.CurrentUserId = cookieUser.userId; //默认个人任务
        this.$store.state.task.searchParams.ServerCenterIds = "";
        break;
    }

    this.classifyChange(this.Alone.TaskClass);

    let promise1 = getAllTag();
    let promise2 = getCommonTag(cookieUser.userId);
    Promise.all([promise1, promise2]).then((values) => {
      console.log("Promise", values);
      let comonTags = values[1].map((tag) => {
        return {
          value: tag.TAGID,
          color: tag.COLOR,
          label: tag.TAGNAME,
        };
      });
      let allTags = values[0].map((tag) => {
        return {
          value: tag.ID,
          color: tag.COLOR,
          label: tag.TAGNAME,
        };
      });

      this.tagOptions = [
        {
          label: "常用标签",
          options: comonTags,
        },
        {
          label: "所有标签",
          options: allTags,
        },
      ];
    });
    // 		this.$root.$on('search',data => {
    // 		this.SearchOpen(data)
    // 		})
    // console.log(this.allVisibleTem,"allVisibleTemallVisibleTem")
    // this.onSearch();
    //this.$store.dispatch("changeTaskParas", this.$store.state.task.searchParams);
  },
  created() {
    let TaskType = JSON.parse(localStorage.getItem("TaskType"));

    this.$store.state.task.taskTypeOptions = TaskType.map(function (val) {
      return {
        label: val.NAME,
        value: val.ID,
        code: val.SPECIALTYPE,
        TEMPLATEID: val.TEMPLATEID,
        CLASSID:val.CLASSID,
        TEMPLATEID:val.TEMPLATEID
      };
    });
    let DefaultTaskTypeView = JSON.parse(
      localStorage.getItem("DefaultTaskTypeView")
    );
    this.TaskViewTypeState = this.$store.state.task.ViewTypeState = DefaultTaskTypeView.map(
      function (val) {
        return {
          name: val.NAME,
          value: val.COMPONENTNAME,
        };
      }
    );

    let TaskTypeByView = JSON.parse(localStorage.getItem("TaskTypeByView"));
    this.$store.state.task.TaskTypeByView = TaskTypeByView.map(function (val) {
      return {
        name: val.NAME,
        value: val.COMPONENTNAME,
        typeId: val.TASKTYPEID,
      };
    });
    this.getServiceList("");
    var _ = require("lodash");
    this.debouncedSearch = _.debounce(this.getServiceList, 1000);
  },
  components: {
    selectCompanyDept,
    selectServiceCenter,
    exportExcel,
    taskSearchTemplate,
    createTemplate,
    selectDeviceExample,
    commomSelect,
    selectFuncRoom,
  },
};
</script>

<style lang="less">
.taskSearch {
  .el-dialog__header {
    padding: 5px 20px;
    border-bottom: 1px solid #d9d9d9;
    background-color: #f0f4fa;
    line-height: 1;
  }

  .el-dialog__headerbtn {
    top: 11px;
  }

  .el-select-dropdown__item {
    padding: 0px 40px 0px 20px;
  }
}
</style>
<style lang="less" scoped>
.el-col {
  margin-top: 0px;
}

.el-autocomplete {
  width: 200px;
}

.searchInput {
  width: 100%;
  /* max-width: 200px; */
  margin-right: 2px;
}

.datePicker {
  margin-right: 2px;
}

.btn {
  width: 100px;
  margin-left: 2px;
  margin-right: 2px;
}

.exportbtn {
  display: inline-block;
}

.searchForm1 {
  margin: 0 0px 0px;
  max-height: 71vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.searchForm1 .el-form-item {
  margin-bottom: 5px;
}

.taskSearch .btnPanel {
  display: flex;
  left: 33%;
  position: relative;
}

.tubiao_div {
  word-wrap: break-word;
}

.taskSearch .el-dialog__header {
  padding: 5px 20px;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f0f4fa;
  line-height: 1;
}

.selectIcon {
  margin-top: 20px;
}

.templateIcon {
  margin-right: 5px;
  margin-bottom: 5px;
}

.templateIcon:hover {
  color: #409eff !important;
}

.el-form-item__content {
  text-align: center;
}

.el-radio {
  margin-right: 5px;
}

.el-radio {
  margin-right: 5px;
}

.el-checkbox {
  margin-right: 5px;
}

.line1 {
  border-bottom: 2px solid #d5dae6;
  margin-bottom: 10px;
}

.lineTop {
  border-top: 2px solid #d5dae6;
  margin-top: 10px;
}

.searchTime {
  width: 80px;
  margin-right: 2px;
}

.inputtime {
  width: 50px;
}

.datePicker {
  width: 100%;
}

.txtleft {
  text-align: left;
}
</style>
<style scoped>
.taskSearch >>> .el-dialog__body {
  padding: 10px 20px;
}

.taskSearch >>> .el-dialog__headerbtn {
  top: 11px;
}

.taskSearch >>> .el-radio__label {
  font-size: 16px;
}

.taskSearch >>> .el-collapse-item__header {
  height: 30px;
  line-height: 30px;
  color: #409eff;
  font-size: 16px;
}

.txtleft >>> .el-radio {
  margin-right: 20px;
}

.taskSearch >>> .el-collapse-item__content {
  padding-bottom: 10px;
}

.taskSearch >>> .el-form-item__label {
  font-size: 16px;
  font-weight: 480;
}

.icon-span {
  font-size: 18px;
}
</style>
